
import Vue from 'vue'
import MenuComplete from '@/components/MenuComplete.vue'
import MaskLoading from '@/components/Mask.vue'
import { StateUiMask } from './store/modules/ui/types'
import { $bus } from '@/main'
import DialogView from '@/views/modals/dialogView.vue'
import ModalView from '@/views/modals/modalView.vue'

// import AuthServiceFactory from '@/services/auth/AuthServiceFactory'
import { DIALOG_LOGOUT } from '@/components/dialogs'
import env from '@/services/environment'
import { TokenInfoService } from '@/services/auth/common/tokenInfo'
export default Vue.extend({
  name: 'App',
  components: {
    MenuComplete,
    MaskLoading,
    DialogView,
    ModalView
  },
  data () {
    return {
      isMobileMode: false,
      isLogin: null,
      username: ''
    }
  },
  computed: {
    contentClass (): Record<string, boolean> {
      return {
        content: !this.isMobileMode && this.isLogin,
        'content-mobile': this.isMobileMode && this.isLogin
      }
    },
    dialogInfo (): any {
      return this.$store.getters['ui/dialogInfo']
    },
    modalInfo (): any {
      return this.$store.getters['ui/modalInfo']
    },
    maskInfo (): StateUiMask {
      return this.$store.getters['ui/maskInfo']
    },
    cachedComponents () {
      return this.$store.getters['ui/openedTabs']
    },
    useTabs (): boolean {
      console.log(env.getEnvVariable('VUE_APP_USE_TABS'))
      return env.getEnvVariable('VUE_APP_USE_TABS').toUpperCase() === 'TRUE'
    }
  },
  mounted () {
    const loginSessionCheck = TokenInfoService.tokenData()
    if (loginSessionCheck && window.location.pathname !== '/') {
      this.$router.push({ name: 'Home' })
    }
    $bus.$on('userAccessResponse', () => {
      this.isLogin = true
      // this.username = 'ADMIN001'
    })

    if (loginSessionCheck && loginSessionCheck.accessToken) {
      this.isLogin = true
    }
  },
  methods: {
    onResize ({ isMobileMode }: { isMobileMode: boolean }) {
      this.isMobileMode = isMobileMode
    },
    onLogoutByMenu () {
      this.$store.dispatch('ui/openDialog', DIALOG_LOGOUT)
    },
    onCloseDialog () {
      this.$store.dispatch('ui/closeDialog')
    },
    onCloseModal () {
      this.$store.dispatch('ui/closeModal')
    }
    // decodeJwt (token: string) {
    //   const base64Url = token.split('.')[1]
    //   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    //   return JSON.parse(window.atob(base64))
    // }
  }
})
